import i18n from 'src/utils/translate';
import NavBar from 'src/components/navBar';

export default function TagNavbar({ tagName, resultsType }: { tagName: string, resultsType: string }) {
  const items = [
    {
      link: `/tag?slug=${tagName}&type=posts`,
      as: `/tag/${tagName}`,
      id: 'posts',
      content: i18n.t('Posts'),
    },
    {
      link: `/tag?slug=${tagName}&type=communities`,
      as: `/tag/${tagName}?type=communities`,
      id: 'communities',
      content: i18n.t('Communities'),
    },
  ];

  return (
    <div>
      <NavBar items={items} selectedPage={resultsType} />
    </div>
  );
}
